import { createContext, useContext } from "react";

import type { ListToolbarContextValue } from "./types-list-toolbar";

export const ListToolbarContext = createContext<ListToolbarContextValue | null>(null);

export function useListToolbarContext(): ListToolbarContextValue {
  const context = useContext(ListToolbarContext);
  if (!context) throw new Error("ListToolbar.* deve ser usado dentro de ListToolbar.Root");
  return context;
}
